/* eslint-disable no-case-declarations */
import { useEffect } from 'react';
import { useToastNotificationsControl } from '@tanium/react-toast-notifications-context';

enum MessageType {
  toast = 'TOAST_NOTIFICATION',
  token = 'REQUEST_TOKEN',
}

interface Message {
  type: MessageType;
}

interface ToastMessage extends Message {
  severity: 'success' | 'error' | 'warning' | 'info';
  contents: string;
}

export const useIframeMessageHandler = (iframeURL: string, authToken?: string) => {
  const { showNotification } = useToastNotificationsControl();

  useEffect(() => {
    const handleMessage = (event: { data: string; origin: string }) => {
      if (event.origin.toLowerCase() === iframeURL.toLowerCase()) {
        try {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const message: Message = JSON.parse(event.data);
          switch (message.type) {
            case MessageType.toast:
              const { severity, contents } = message as ToastMessage;
              showNotification({ type: severity, contents });
              break;
            case MessageType.token:
              const iframe = document.querySelector('iframe');
              const handle = iframe?.contentWindow;
              if (authToken) {
                handle?.postMessage({ jwt: authToken }, iframeURL);
              }
              break;
            default:
              break;
          }
        } catch {
          // no-op
        }
      }
    };

    window.addEventListener('message', handleMessage); // Cleanup the event listener on component unmount

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [authToken, iframeURL, showNotification]);
};
